import { type MenuItemLinkViewModel, PageActionDiscriminator } from 'autogen/swagger/all';
import type { RevieveActionTypes } from 'components/shared/Routing/components/CustomAction/shared/types';
import useIsPathnameActive from 'components/sideMenu/shared/hooks/useIsPathnameActive';
import { GA4Tracking } from 'modules/tracking/GA4';
import type { DefaultMenuItemProps } from '../types';
import DefaultMenuItem from './DefaultMenuItem';
import RevieveHookMenuItemButton from './RevieveHookMenuItemButton';

type LinkMenuItemProps = {
    model: MenuItemLinkViewModel;
    defaultProps: DefaultMenuItemProps;
};

export default function LinkMenuItem({
    model: { pageAction, target, title, text, productGroupPath },
    defaultProps: { iconUrl, styling, id },
    ...restProps
}: LinkMenuItemProps) {
    const isSelected = useIsPathnameActive(productGroupPath?.url);

    return PageActionDiscriminator(
        pageAction,
        (customPageAction) => {
            if (customPageAction.action.$type === 'JavascriptHookCustomAction') {
                switch (customPageAction.action.javascriptHookType) {
                    case 'MakeupAdvisor':
                    case 'InStoreMakeupAdvisor':
                    case 'SkinAnalytics':
                    case 'InStoreSkinAnalytics':
                        return (
                            <RevieveHookMenuItemButton
                                javascriptHookType={customPageAction.action.javascriptHookType as RevieveActionTypes}
                                iconUrl={iconUrl}
                                styling={styling}
                                text={text}
                                isSelected={isSelected}
                            />
                        );
                    default:
                        return null;
                }
            }
            return null;
        },
        (linkAction) => (
            <DefaultMenuItem.Anchor
                anchorProps={{ action: linkAction.action, target, title }}
                selected={isSelected}
                styling={styling}
                iconUrl={iconUrl}
                onClick={() => {
                    GA4Tracking({
                        eventName: 'link_click',
                        context: 'menu',
                        category: 'navigation',
                        eventParams: [
                            { param_name: 'link_type', param_value: 'internal' },
                            { param_name: 'list_name', param_value: text },
                            { param_name: 'id', param_value: id }
                        ]
                    });
                }}
                {...restProps}
            >
                {text}
            </DefaultMenuItem.Anchor>
        ),
        () => null
    );
}
